import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule, FlexModule } from "@angular/flex-layout";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { TranslateModule } from "@ngx-translate/core";
import { NoAuthGuard } from "./guard/no-auth.guard";
import { CommunicationService } from "./service/Communication/communication.service";
import { CommunicationMessageComponent } from "./service/Communication/components/communication-message/communication-message.component";

@NgModule({
    declarations: [CommunicationMessageComponent],
    imports: [
        CommonModule,
        MatIconModule,
        TranslateModule,
        FlexModule,
        FlexLayoutModule,
        MatButtonModule,
        MatSnackBarModule,
        MatDialogModule
    ],
    providers: [NoAuthGuard, CommunicationService]
})
export class CoreModule {}
